<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"></SearchField>

    <Table ref="table" :tableHeight="tableHeight2" :tableData="tableData" :cols="cols" :page="page" :limit="limit"
      :total="total" :showIndex="true" :btns="btns" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
import mixin from "../../mixin";

export default {
  mixins: [tableMixin, mixin],
  data() {
    return {
      formInline: {
        ischeck: 1,
        isstatus: 1,
      },
      formCtrl: [
        {
          label: "装货日期：",
          keyName: "starttime",
          placeholder: "选择日期",
          type: "daterange",
        },
        { ...this.ctrls.license },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>
